import { colors, dims } from "../../styles";
import imgSrc from "./bh-3.jpg";

export default {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    minHeight: "100vh",
    maxHeight: "100vh",
    overflowY: "scroll",
    fontFamily: "Hind",
    width: "100%",
    backgroundColor: colors.black,
    backgroundImage: `url("${imgSrc}")`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "50% 50%",
    backgroundSize: "cover",
  },
  nav: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: dims.nav,
    fontSize: 14,
    width: "100%",
    marginBottom: 16,
  },
  content: {
    display: "flex",
    justifyContent: "center",
    flexGrow: 1,
    width: "90%",
  },
};



// WEBPACK FOOTER //
// ./src/components/Layout/styles.js